var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbAppIconEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 17.79,
    viewBox: "0 0 20.002 17.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.23 60.28-1.5-1.5a.36.36 0 0 0-.51 0l-1.07 1.07 2.02 2.02 1.07-1.07a.384.384 0 0 0-.01-.52m-2.25 2.76-2.02-2.02-6.45 6.46-.25 2.27 2.27-.25zm3.43-1.07-9.12 9.12-3.14.35a1.433 1.433 0 0 1-1.58-1.58l.35-3.14 9.12-9.12a2.016 2.016 0 0 1 2.87 0l1.5 1.5a2.034 2.034 0 0 1 0 2.87m-5.44 7.01 1.11-1.11a.284.284 0 0 1 .48.2v5.05a1.673 1.673 0 0 1-1.67 1.67H29.67A1.673 1.673 0 0 1 28 73.12V60.89a1.673 1.673 0 0 1 1.67-1.67h9.5a.283.283 0 0 1 .2.48l-1.11 1.11a.28.28 0 0 1-.2.08h-8.39v12.22h12.22v-3.94a.27.27 0 0 1 .08-.19",
    "data-name": "Path 1185"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-1h30v30H-2z",
    "data-name": "Rectangle 6311"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11792",
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-28 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11791",
    style: {
      clipPath: "url(#b)"
    },
    transform: "translate(23 52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v27.78H0z",
    "data-name": "Rectangle 6310",
    style: {
      fill: "#333"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconEditing);
export default __webpack_public_path__ + "static/media/tb_app_icon_editing.d4fb79d65bf694111c59115a203f08ea.svg";
export { ForwardRef as ReactComponent };